import { RPDXImportOption } from '@/app/assets/actions/importOptions';
import QuestionMarkIcon from '@/icons/question-mark.svg';
import { Box, Group, HoverCard, Select, Stack, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useEffect } from 'react';

export const CADOptionField = ({
  option,
  form,
}: {
  option: RPDXImportOption;
  form: UseFormReturnType<Record<string, any>>;
}) => {
  const schema = option.option_subschema;

  return (
    <Stack gap={4}>
      <Group gap='xs'>
        <Text fw={600}>{schema.title}</Text>
        <HoverCard width={280} shadow='md'>
          <HoverCard.Target>
            <Box>
              <QuestionMarkIcon />
            </Box>
          </HoverCard.Target>
          <HoverCard.Dropdown>
            <Text size='sm'>{schema.description}</Text>
          </HoverCard.Dropdown>
        </HoverCard>
      </Group>
      {schema.enum ? (
        <Select
          data={schema.enum.map((o: string) => ({
            label: o,
            value: o,
          }))}
          comboboxProps={{ withinPortal: false }}
          {...form.getInputProps(option.schema_path)}
        />
      ) : (
        <Text c='red'>Not implemented! Please contact the customer service!</Text>
      )}
    </Stack>
  );
};
